var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpLeftArrow5728816(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "up-left-arrow_5728816",
    d: "M4.883,0H15.117A4.892,4.892,0,0,1,20,4.883V15.117A4.892,4.892,0,0,1,15.117,20H4.883A4.892,4.892,0,0,1,0,15.117V4.883A4.892,4.892,0,0,1,4.883,0ZM7.495,16.055H9.409V9.409h6.646V7.495H7.495ZM5.859,12.505V5.859h6.646V3.945H3.945v8.56Z",
    fill: "#7d96ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpLeftArrow5728816);
export default __webpack_public_path__ + "static/media/up-left-arrow_5728816.2013cc8d6be0f08179eab035372c8068.svg";
export { ForwardRef as ReactComponent };